import { PerformanceAudienceFilterOption, PerformanceAudienceSummary } from '@/services/endpoints/performanceAudience';
import { SelectOption } from '@/lib/Selects/Select/types';
import { FC } from 'react';
import { PerformanceAudienceFilterCard } from '../PerformanceAudienceFilterCard';

type PerformanceAudienceFiltersProps = {
  isRefetching?: boolean;
  summary?: PerformanceAudienceSummary;
  audiences: PerformanceAudienceFilterOption[];
  googleScopes: PerformanceAudienceFilterOption[];
  metaScopes: PerformanceAudienceFilterOption[];
  dateRanges: PerformanceAudienceFilterOption[];
  selectedAudienceId: string;
  selectedGoogleScopeId: string;
  selectedMetaScopeIds: string[];
  selectedDateRangeId: string;
  selectedDateFrom?: string;
  selectedDateTo?: string;
  onAudienceChange: (option: SelectOption) => void;
  onGoogleScopeChange: (option: SelectOption) => void;
  onMetaScopeIdsChange: (ids: string[]) => void;
  onDateRangeChange: (option: SelectOption) => void;
  onCustomDateRangeApply: (range: { from: string; to: string }) => void;
};

export const PerformanceAudienceFilters: FC<PerformanceAudienceFiltersProps> = (props) => {
  return <PerformanceAudienceFilterCard {...props} />;
};
